import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";


const initialState = {
  value: [],
  loading: false,
};

export const addHomeHealth = createAsyncThunk(
  "homeHealth/addHomeHealth",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.addHomeHealthOrder(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const addHomeHealthSlice = createSlice({
  name: "addHomeHealth",
  initialState,
  reducers: {
    clearAddHomeHealthResponse(state, action) {
      state.value = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addHomeHealth.pending, (state) => {
        state.loading = true;
      })
      .addCase(addHomeHealth.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(addHomeHealth.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const addHomeHealthList = (state) => state.addHomeHealth.value;
export const addHomeHealthListLoading = (state) => state.addHomeHealth.loading;
export const { clearAddHomeHealthResponse } = addHomeHealthSlice.actions;
export default addHomeHealthSlice.reducer;
